import axios from 'axios'
import { apiConfigAuthenticated } from '@/api/config'

export let apiGetPages = function (token) {
  return axios.get('/api/v0/statistic/templates/',
    apiConfigAuthenticated(token))
}

export let apiCreatePage = function (data, token) {
  return axios.post('/api/v0/statistic/templates/',
    data,
    apiConfigAuthenticated(token, 'multipart/form-data'))
}

export let apiEditPage = function (id, data, token) {
  return axios.patch(`/api/v0/statistic/templates/${id}/`,
    data,
    apiConfigAuthenticated(token, 'multipart/form-data'))
}

export let apiDeletePage = function (id, token) {
  return axios.delete(`/api/v0/statistic/templates/${id}/`,
    apiConfigAuthenticated(token))
}



// WEBPACK FOOTER //
// ./src/api/templates.js